// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"300":"9f01372b","326":"b87bb4b7","475":"0241f775","698":"bc1aa041","856":"6113b694"}[chunkId] + ".js";
};